//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPoster } from '@/model/distribution/distributionService'
import { toApp } from '@/utils/appBridge.js'
import { signatureOss,ossImg } from "@/model/api/commonUtilsService";
import { getNum } from "@/utils/commonUtils.js"
import md5 from 'js-md5';

export default {
  data() {
    return {
      // key: value
      wechat:'新氧推出的「牙齿清洁保障计划」，很实用。超声波洁牙99块钱，家门口就有严选优质机构，3颗蛀牙打了8折，一年内再有蛀牙，免费给治！实惠！推荐你看看~',
      dataImg:'',
      imgData: null,
      text:'点击「保存图片」生成你的专属海报',
      channalId:"APP",
      base:''
    }
  },
  created() {
    console.log(new Date().getTime() + getNum())
    getPoster().then(res  =>{
      this.dataImg = `data:image/png;base64,${res.poster_data}`
      this.base = res.poster_data
      console.log(res)
    })
  },
  mounted () {
    this.channalId = this.CHANNAL_ID
    if(this.channalId == 'APP'){
      this.text = '点击「保存图片」生成你的专属海报'  
    }else{
      this.text = '长按保存专属海报'

    }
    this.STATISTICS('load','sybao_ins_distri_poster_page')
  },
  methods:{
    copy(){
      this.STATISTICS('click','sybao_ins_distri_poster_copyword_click')
    },
     //复制成功
    onCopy(e){
      //console.log(e);
      this.$toast("复制成功");
    },
    //复制失败
    onError(e){
      this.$toast("复制失败");
    },
    downloadImg(){
      this.STATISTICS('click','sybao_ins_distri_poster_savepic_click')
      this.upload()
    },
   
    convertImgDataToBlob(base64Data) {
                var format = "image/jpeg";
                var base64 = base64Data;
                var code = window.atob(base64.split(",")[1]);
                var aBuffer = new window.ArrayBuffer(code.length);
                var uBuffer = new window.Uint8Array(aBuffer);
                for(var i = 0; i < code.length; i++){
                    uBuffer[i] = code.charCodeAt(i) & 0xff ;
                }
                console.info([aBuffer]);
                console.info(uBuffer);
                console.info(uBuffer.buffer);
                console.info(uBuffer.buffer==aBuffer); //true
                var blob=null;
                try{
                    blob = new Blob([uBuffer], {type : format});
                }
                catch(e){
                    window.BlobBuilder = window.BlobBuilder ||
                    window.WebKitBlobBuilder ||
                    window.MozBlobBuilder ||
                    window.MSBlobBuilder;
                    if(e.name == 'TypeError' && window.BlobBuilder){
                        var bb = new window.BlobBuilder();
                        bb.append(uBuffer.buffer);
                        blob = bb.getBlob("image/jpeg");
                    }
                    else if(e.name == "InvalidStateError"){
                        blob = new Blob([aBuffer], {type : format});
                    }
                    else{
                    }
                }
                return blob;
    },
    upload(e){
        // 先准备好 oss 服务器需要的内容
        const name = md5(new Date().getTime() + getNum())
        const parmer = {object_name:""}
        parmer.object_name = `fission/poster/${name}.jpeg`
        signatureOss(parmer).then(res=>{
        const photo  = this.convertImgDataToBlob(this.dataImg); // 获取图片对象
        const photoName = name // 原图片的名称
        const key = res.dir  // 存储到oss的图片名称 自己定，必须确保唯一性，不然会覆盖oss中原有的文件
        const policy = res.policy  // 服务器端同事调oss的API，通过接口返回给前端的 policy
        const OSSAccessKeyId = res.accessid  // 服务器端同事调oss的API，通过接口返回给前端的 OSSAccessKeyId
        const callback = res.callback  // 服务器端同事调oss的API，通过接口返回给前端的 callback。这个是需要 oss 触发这个回调来通知服务器操作结果。
        const signature = res.signature  // 服务器端同事调oss的API，通过接口返回给前端的 signature。这个就是签名，最关键的。
        const url = res.host
        
        // biu一下，提交给oss
        let param = new FormData(); 
        param.append('name', `${photoName}`)
        param.append('key', `${key}`)
        param.append('policy', `${policy}`)
        param.append('OSSAccessKeyId', `${OSSAccessKeyId}`)
        param.append('success_action_status', 200)  // 不要问为什么，照做
        param.append('callback', `${callback}`)
        param.append('signature', `${signature}`) 
        param.append('file', photo, photoName); // 这个**切记**一定要放到最后去 append ，不然阿里云会一直报 key 的错误
        console.log('eqwewqewq',url+key)
        const dataImg = url+ '/' +key
        setTimeout(()=>{
          toApp('downloadImg',
            { downloadImgUrl:dataImg}
          )
        },300)
        this.$toast("保存成功");

        
        ossImg(param,url ).then(response => {

        })
        .catch((err) => {
            console.log("err == ", err)
        })
        })
        
    }
  }
}
